module.exports = __webpack_public_path__ + "static/media/hdi_color.503100a4.png";